import { Injectable } from '@angular/core';
import { EcomNetworkUtils } from '@src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { MMOutput } from '@src/app/ecom-models/response-model';
import { EComService } from '@src/app/ecom-services/ecom-common.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Injectable()
export class EcomSigninService {

    constructor(public ecomservice: EComService) {

    }

    verifyUser(data: any): Observable<MMOutput> {
        return this.ecomservice.httpPost(EcomNetworkUtils.POST_VERIFY_SOCIAL_USER, data, '', true)
            .pipe(switchMap(result => of(result)));
    }

    fetchUserByPkid(data: any): Observable<MMOutput> {
        return this.ecomservice.httpPost(EcomNetworkUtils.SOCIAL_AUTH_GET_USER_BY_PKID, data, '', true)
            .pipe(switchMap(result => of(result)));
    }

    generateKey(): Observable<MMOutput> {
        return this.ecomservice.httpPost(EcomNetworkUtils.POST_GENERATEKEY, {}, '', true)
            .pipe(switchMap(result => of(result)));
    }


}




